// extracted by mini-css-extract-plugin
module.exports = {"c1vqlek":"c1vqlek","n1wsbqts":"n1wsbqts","n57rna2":"n57rna2","b94yrz":"b94yrz"};